export const GREATER_THAN = 'GreaterThan';
export const EQUAL_TO = 'EqualTo';
export const LESS_THAN = 'LessThan';